import { render, staticRenderFns } from "./TodayClassSchedules.vue?vue&type=template&id=4a603e27"
import script from "./TodayClassSchedules.vue?vue&type=script&lang=js"
export * from "./TodayClassSchedules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports